import React from 'react';
import { useSelector } from 'react-redux';
import { getBackAndNext } from 'helpers/navigation';
import { RootState } from 'types/state';
import SectionNavButton from './SectionNavButton';

interface Props {
  backRef: React.RefObject<HTMLAnchorElement>
  currentPath: string
}

const SectionNavigation: React.FC<Props> = ({ currentPath, backRef }) => {
  const { back, next } = useSelector((state: RootState) => getBackAndNext(state, currentPath));
  if (!back && !next) { return null; }

  return (
    <div className="bottom-btns">
      <div className="btn-wrap">
        <div className="btn-container">
          <SectionNavButton
            ref={backRef}
            direction="back"
            label={back && back.navLabel}
            link={back && back.fullPath}
          />
          <div className="btn-spacer" />
          <SectionNavButton
            direction="next"
            label={next && next.navLabel}
            link={next && next.fullPath}
          />
        </div>
      </div>
    </div>
  );
};

export default SectionNavigation;
